// components
import maInputText from '@/components/input/modules/text'
import maInputTextDescription from '@/components/input/modules/textDescription'
import maInputTextNumbers from '@/components/input/modules/textNumbers'
import maInputSelect from '@/components/input/modules/select'
import maInputRadio from '@/components/input/modules/radio'
import maInputCheckbox from '@/components/input/modules/checkbox'
import maInputTextmap from '@/components/input/modules/textmap'
import maInputTextmapline from '@/components/input/modules/textmapline'
import maInputImgradio from '@/components/input/modules/imgRadio'
import maInputSelectMap from '@/components/input/modules/selectmap'
import maInputBtn from '@/components/input/modules/btn'
import maInputFile from '@/components/input/modules/fileImg'
import maSpinner from '@/components/spinner'

import debounce from '@/utils/debounce'

// vuex
import { mapState, mapMutations } from 'vuex'

// types
import { WARRANTY_MODULE_NAME, WARRANTY_UPDATE_MURS_COUNT } from '@/store/types'

/**
 * @module
 * @name Form
 * @description Dynamic form
 */
export default {
  name: 'Form',
  /**
   * @property {String} type CSS style
   * @property {Object} formData Form components will be rendered according
   *                             to this object.
   */
  data: function () {
    return {
      formIsOpen: true,
      counterAmount: 0,
      valueInput: null
    }
  },
  props: {
    type: {
      type: String,
      required: true
    },
    formData: {
      type: Object,
      required: false
    },
    categoryTitle: {
      type: String,
      required: false
    },
    categoryLiteral: {
      type: String,
      required: false
    },
    showDropDown: {
      type: Boolean,
      required: false
    },
    handleChangeFile: {
      type: Function,
      required: false
    },
    titleFileInputEnsemble: {
      type: String,
      required: false
    },
    nameFileInputEnsemble: {
      type: String,
      required: false
    },
    inputImgListEnsemble: {
      type: Array,
      required: false
    },
    titleFileInputPres: {
      type: String,
      required: false
    },
    nameFileInputPres: {
      type: String,
      required: false
    },
    inputImgListPres: {
      type: Array,
      required: false
    },
    showLiteral: {
      type: Boolean,
      required: false,
      default: true
    },
    showSpinner: {
      type: Boolean,
      required: false
    },
    hasUploadImgs: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  components: {
    maInputText,
    maInputTextDescription,
    maInputTextNumbers,
    maInputSelect,
    maInputRadio,
    maInputCheckbox,
    maInputTextmap,
    maInputTextmapline,
    maInputImgradio,
    maInputSelectMap,
    maInputBtn,
    maInputFile,
    maSpinner
  },

  /**
   * @property {Boolean} agentView From state, it shows different input components
   *                               depending on if we're working with agentView
   *                               or not.
   * @property {Object} stateWarrantyCoordinates Retrieved from state, set in
   *                                             sinister address for inputs that
   *                                             need it.
   */
  computed: {
    ...mapState({
      agentView: (state) => state.agentView
    }),
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantyCoordinates: 'coordinates',
      stateWarrantyCounterMurs: 'counterMurs'
    })
  },
  methods: {
    ...mapMutations(WARRANTY_MODULE_NAME, {
      mutStateWarrantyUpdateMursCount: WARRANTY_UPDATE_MURS_COUNT
    }),
    /**
     * @function
     * @name handleEvent
     * @description Wrapper that emits and event including if hasNestedComponents,
     *              and inputId, inputVal of the input that emit an event.
     * @param {String} action input, change... basically event method.
     * @param {Boolean} hasNestedComponents If there are nested components, form
     *                                      should be refreshed.
     * @param {Boolean} inputId Input id of transmitter event input.
     * @param {Boolean} inputVal Input value of transmitter event input.
     * @return {Object}
     */
    handleEvent: function (
      action,
      hasNestedComponents,
      inputId,
      inputVal,
      categoryTitle
    ) {
      this.$emit(action, {
        hasNestedComponents,
        inputId,
        inputVal,
        categoryTitle
      })
    },

    handleEventDelay: debounce(function (
      action,
      hasNestedComponents,
      inputId,
      inputVal,
      categoryTitle
    ) {
      this.$emit(action, {
        hasNestedComponents,
        inputId,
        inputVal,
        categoryTitle
      })
    },
    1000),

    handleFileChangeImaEnsemble(fileData, categoryTitle) {
      this.$emit('file:change-ensemble', { fileData, categoryTitle })
    },
    handleFileChangeImgPres(fileData, categoryTitle) {
      this.$emit('file:change-pres', { fileData, categoryTitle })
    },
    /**
     * This method returns the number of columns for the input. For now is only
     * used for select inputs. Depending on how many options the select have.
     * For just one, an input text will be displayed so full width(4 columns)
     * is needed.
     */
    numberOfColumns(input) {
      return input.options.length === 1 ? '4' : input.col
    }
  }
}
